import type { FormProps, Input } from '../../types'
import style from '../form.module.css'

export default function CustomInput({
  field,
  formProps,
}: {
  field: Input
  formProps: FormProps
}) {
  return (
    <input
      type={field.uiOptions?.inputType || 'text'}
      placeholder={field.uiOptions?.placeholder}
      className={style.customInput}
      {...formProps?.register(field.name, {
        value: field.value,
      })}
      data-testid={field.uiOptions?.testId}
      disabled={field.uiOptions?.disabled}
    />
  )
}
